import { Text } from '@components/Helpers'
import Button from '@components/Furry/Button'
import { useTranslation } from 'react-i18next'
import CryingCat from '@assets/crying-cat.webp'
import Image from 'next/image'
import { cn } from '@utils/index'

type ErrorMessageProp = {
  onRetry?: () => void
  text?: string
  className?: string
}

const ErrorMessage = ({ onRetry, text, className }: ErrorMessageProp) => {
  const { t } = useTranslation()

  return (
    <div className={cn('flex flex-col items-center mt-1', className)}>
      <div className="flex flex-row items-center mb-2">
        <Text
          sx={{ fontSize: '1.5rem', fontWeight: 'bold', marginRight: '0.4rem' }}
        >
          {text || t('generic.error.message')}
        </Text>
        <Image alt="" src={CryingCat} width={30} height={30} />
      </div>
      {onRetry && (
        <Button onClick={onRetry}>{t('generic.error.buttonTitle')}</Button>
      )}
    </div>
  )
}

export default ErrorMessage
